/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from "react";
import { Input, message, Row, Button } from "antd";

import {
  capitalise,
  capitalize,
  dateFormat,
  capitalizeWithComma,
  getUserAndPremiseId,
  serialNum,
} from "../../../utils";
import { useNavigate, useParams } from "react-router-dom";

import TableContainer from "../../../components/TableContainer";
import {
  APIs,
  getPremiseId_,
  getPremiseId,
  getToken,
} from "../../../utils/worker";
// import { ReactComponent as Edit_icon } from "../../../assests/images/edit-logo.svg";

import axios from "axios";
import urls from "../../../api/urls";
import API from "../../../api";
import Heading from "../../../components/Heading";
import ProceedModal from "../../viewBookingTable/Addpacket/proceedModal";
// import ConfirmationModal from "./confirmationModal";

const { GET_LCR_SCANNED_BAGS, GET_LCR_BAG_LIST, UPDATE_ALL_PACKETS } = urls;

// import "./style.scss";

const InScanLCRTable = () => {
  const navigate = useNavigate();
  const getUserInfo = getUserAndPremiseId();
  let userPremiseId = getPremiseId_();

  const [loading, setLoading] = useState(false);
  const [currentScanNum, setcurrentScanNum] = useState([]);
  const [scannedAwbs, setScannedAwbs] = useState([]);
  const [columnsShipments, setColumnsShipments] = useState();
  const [tableData, setTableData] = useState();
  const [dataSource, setdataSource] = useState(tableData);
  const [total, setTotal] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(0);

  let mockData = [
    {
      id: 1102,
      bagBarcodeNo: 23200000437,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "surface",
      contentType: "NON-DOX",
      contentTypeList: null,
      mode: "standard",
      modeList: null,
      premiseId: 52,
      weight: 5.27,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#D2DD3F",
      eligibleContent: null,
      createdDate: "2023-05-24 10:27:55",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 754,
          barcodeNo: 23495100000990,
          barcodeBaggingStatus: null,
          barcodeType: "1",
          weight: 5.0,
          childShipments: null,
        },
        {
          id: 755,
          barcodeNo: 23400000186,
          barcodeBaggingStatus: null,
          barcodeType: "6",
          weight: 0.27,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 859,
      bagBarcodeNo: 23200000435,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "surface",
      contentType: "NON-DOX",
      contentTypeList: null,
      mode: "standard",
      modeList: null,
      premiseId: 52,
      weight: 13.0,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#fff",
      eligibleContent: null,
      createdDate: "2023-05-23 12:47:35",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 627,
          barcodeNo: 23495100000993,
          barcodeBaggingStatus: null,
          barcodeType: "1",
          weight: 5.0,
          childShipments: null,
        },
        {
          id: 628,
          barcodeNo: 23495100000992,
          barcodeBaggingStatus: null,
          barcodeType: "1",
          weight: 8.0,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
    {
      id: 1152,
      bagBarcodeNo: 23200000441,
      status: "HUB-IN-SCANNED",
      destinationHubId: 114,
      travelBy: "air",
      contentType: "DOX",
      contentTypeList: null,
      mode: "standard,fast track",
      modeList: null,
      premiseId: 52,
      weight: 2.36,
      shipmentsTotalweight: null,
      readinessStatus: "READY_FOR_MANIFEST_BAG_SORT_OR_OUTSCAN",
      destinationName: null,
      bagColour: "#2E7FE1",
      eligibleContent: null,
      createdDate: "2023-05-25 16:52:25",
      updatedDate: null,
      isBag: null,
      bagContents: [
        {
          id: 802,
          barcodeNo: 23300000057,
          barcodeBaggingStatus: null,
          barcodeType: "5",
          weight: 2.364,
          childShipments: null,
        },
      ],
      eligibleBagContents: null,
    },
  ];

  const columns = [
    {
      title: "Sl No",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 50,
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Bag Id",
      dataIndex: "bagBarcodeNo",
      key: "bagBarcodeNo",
      width: 90,
      render: (text, val, index) => {
        return (
          <>
            <span
              className={"mr-1 pointer"}
              style={{
                color: "#4394d3",
              }}
              onClick={() => navigate("/bag-contents/" + text)}
            >
              {text}
            </span>
            {/* {val?.status === "HUB-IN-SCANNED" ? <Scan_check /> : null} */}
          </>
        );
      },
    },
    {
      title: "From Hub",
      dataIndex: "frommHub",
      key: "frommHub",
      width: 90,
      render: (text) => {
        return capitalize(text) || "---";
      },
    },
    {
      title: "To Hub",
      dataIndex: "destinationName",
      key: "destinationName",
      width: 90,
      render: (text) => {
        return capitalize(text) || "---";
      },
      // width: 400,
    },

    // {
    //   title: "Service Type",
    //   dataIndex: "travelBy",
    //   key: "travelBy",
    //   // width: 100,
    //   render: () => {
    //     return "Air";
    //   },
    // },

    {
      title: "Service Type",
      dataIndex: "mode",
      key: "mode",
      width: 100,
      render: (text) => {
        if (text.includes(",")) {
          return capitalizeWithComma(text) || "---";
        } else {
          return capitalize(text) || "---";
        }
      },
    },
  ];

  useEffect(() => {
    getTableData();
  }, []);

  useEffect(() => {
    setColumnsShipments(columns);
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
  };

  const getTableData = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_LCR_SCANNED_BAGS + `/${userPremiseId}/status/HUB-IN-SCANNED`
    ).getWithUserNPremiseHeader();

    if (response?.status) {
      setLoading(false);
      setTotal(response?.response?.data.length);
      setTableData(response?.response?.data);
    } else {
      if (!response.status) {
        setLoading(false);
      }
    }
    // setTableData(mockData, "mockData");
  };
  const [inputSearchValue, setInputSearchValue] = useState("");

  const onSearch = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(tableData, currValue)
        : filterArray(tableData, currValue);
    setdataSource(filteredData);
    setTotal(filteredData?.length);

    // setPageNum(0);
  };

  const filterArray = (dataSource, currValue) =>
    dataSource?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  function handlePageChange(pagination) {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
  }

  return (
    <div className="p-2">
      <Heading title="Scanned Bag List" />
      <div className="master-main-container">
        <div className="align-center space-between">
          <div className="pl-1-5 fw-600"></div>
        </div>

        <Row className="header space-between">
          <div className="title"></div>
          <div className="right">
            <Input
              maxLength={14}
              placeholder="Enter keyword to search"
              bordered
              style={{
                borderRadius: "5px",
                height: "40px",
                // width: "100%",
                margin: "15px 33px 15px -12px",
              }}
              onChange={onSearch}
            />
          </div>
        </Row>
        <TableContainer
          columns={columnsShipments}
          loading={loading}
          // dataSource={tableData}
          dataSource={inputSearchValue.length == 0 ? tableData : dataSource}
          pagination={{
            pageSize: pageSize,
            total: total,
            itemRender: itemRender,
            current: pageNum == 0 ? +1 : pageNum,
          }}
          onChange={handlePageChange}
          scroll={{
            x: 700,
            y: 500,
          }}
        />
      </div>

      <div className="d-flex flex-end mt-1" style={{ display: "flex" }}>
        <Button
          className="save-btn"
          style={{ textAlign: "end" }}
          onClick={() => navigate("/hub-in-scan")}
          // onClick={() => navigate("/lcr-packets-scan/" + params?.id)}
          // onClick={handleOpenBag}
        >
          {"SUBMIT"}
        </Button>
      </div>
    </div>
  );
};

export default InScanLCRTable;
